export * from './landing-page-footer'
